import { render } from "./TotalSalesReportGrapics.vue?vue&type=template&id=416b0db0"
import script from "./TotalSalesReportGrapics.vue?vue&type=script&lang=js"
export * from "./TotalSalesReportGrapics.vue?vue&type=script&lang=js"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__